(($)=>{

    const ANIMATION_TIME = 300;

    $('[data-details-drawer]').each(function initDrawer(){
        const $el =  $(this),
            $toggle = $('[data-details-toggle]', $el),
            $content = $('[data-details-content]', $el),
            $moreContent = $('[data-details-more]', $el),
            $moreToggle = $('[data-details-more-toggle]', $el);


        if($moreToggle.attr('aria-expanded') === 'true'){
            $moreContent.slideDown(0);
            $moreToggle.text('Show Less');
        }else{
            $moreContent.slideUp(0);
            $moreToggle.text('Show More');
        }

        $toggle.on('click', function toggleMainDrawer(event){
            const $btn = $(this);
            if($btn.attr('aria-expanded') === 'true'){
                $btn.attr('aria-expanded', 'false');
                $content.slideUp(ANIMATION_TIME);
            }else{
                $btn.attr('aria-expanded', 'true');
                $content.slideDown(ANIMATION_TIME);
            }
            event.preventDefault();
        });

        $moreToggle.on('click', function toggleMoreLessDrawer(event){
            const $btn = $(this);
            if($btn.attr('aria-expanded') === 'true'){
                $btn.text('Show More');
                $btn.attr('aria-expanded', 'false');
                $moreContent.slideUp(ANIMATION_TIME);
            }else{
                $btn.text('Show Less');
                $btn.attr('aria-expanded', 'true');
                $moreContent.slideDown(ANIMATION_TIME);
            }
            event.preventDefault();
        });

        $(window).on('load resize', function initStates(){
            if($toggle.is(':visible')){
                // let's set initial states based on aria-expanded.
                if($toggle.attr('aria-expanded') === 'true'){
                    $content.slideDown(0);
                }else{
                    $content.slideUp(0);
                }
            }else{
                $content.slideDown(ANIMATION_TIME);
            }
        });

    });

})(jQuery)